module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/Combo.f739619a.svg";